
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 24/02/2025
 * @update 24/02/2025
 * @file src/components/W17/W17F1404
 */

import Api from "../../../services/api";

export function loadCboEmployee(cb) {
    return () => {
        Api.get('/w17f1404/load-cbo-employee')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCboCustomer(params, cb) {
    return () => {
        Api.put('/w17f1404/load-cbo-customer', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadForm(params, cb) {
    return async () => {
        Api.put('/w17f1404/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadAttachmentImage(params, cb) {
    return async () => {
        Api.put('/w17f1404/load-cbo-attachment-images', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
